/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReplyIcon = /*#__PURE__*/ createSvgIcon(
  'ReplyIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5 16l-1.727 1.727c-.237.237-.51.291-.815.16-.305-.13-.458-.364-.458-.7V4.5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44H5zm-.625-1.5H16.5v-10h-13v10.875l.875-.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ReplyIcon;
